import { Component, Input, OnInit } from '@angular/core';

import { PageHeaderResponseJSON } from "./../common/JSON/surveyHeader/Page-Header-Response-JSON";


@Component({
  selector: 'altSurvey-header',
  templateUrl: './Header.component.html'
})
export class HeaderComponent implements OnInit {

  public bannerImageVisible = true;
  public uploadedLeftLogoVisible = true;
  public uploadedRightLogoVisible = true;
  @Input() pageHeaderResponseJSON: PageHeaderResponseJSON;

  isClassVisible: boolean = true;

  constructor() {}

  ngOnInit() {
    console.log("Inside Header : "+this.pageHeaderResponseJSON.uploadedLogoPath);
    if((this.pageHeaderResponseJSON.uploadedLogoPath == null) || this.pageHeaderResponseJSON.uploadedLogoPath == "" || this.pageHeaderResponseJSON.uploadedLogoPath == "NULL"){
     
      this.bannerImageVisible = false;
    }
    if((this.pageHeaderResponseJSON.uploadedLeftLogoPath == null) || this.pageHeaderResponseJSON.uploadedLeftLogoPath == "" || this.pageHeaderResponseJSON.uploadedLeftLogoPath == "NULL"){
      this.uploadedLeftLogoVisible = false;
    }
    if((this.pageHeaderResponseJSON.uploadedRightLogoPath == null) || this.pageHeaderResponseJSON.uploadedRightLogoPath == "" || this.pageHeaderResponseJSON.uploadedRightLogoPath == "NULL"){
      this.uploadedRightLogoVisible = false;
    }
    
  }

}